
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pros",
      function () {
        return require("private-next-pages/pros/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pros"])
      });
    }
  